// @ts-check

import { modalContainer, closeButton } from "./main";
import { getAll, get } from "../utilities/querySelector";
import { textToHTML } from "../utilities/textToHtml";
import { formatNumber } from '../utilities/numbers';

const modal = get( '[data-modal="quick-spec"]', modalContainer );

const gallery_slot = get( '[data-spec-gallery]', modal );
const title_slot = get( '[data-spec-title]', modal );
const price_slot = get( '[data-spec-price]', modal );
const content_slot = get( '[data-spec-content]', modal );
const length_slot = get( '[data-spec-length]', modal );
const width_slot = get( '[data-spec-width]', modal );
const link_slot = get( '[data-spec-link]', modal );
const features_slot = get( '[data-spec-features]', modal );
const enquire_slot = get( '[data-modal-open="enquiry"]', modal );

const items = getAll( '.card--hut' );

items.forEach( setUpModalEvents );

async function setUpModalEvents( item ) {
    const trigger = get( '[data-modal-open="quick-spec"]', item );

    trigger.addEventListener( 'click', async () => {
        modal.classList.remove( 'error' );
        modal.classList.add( 'loading' );
        const data = await fetchHutData( trigger.dataset.hut );

        if ( data instanceof Error ) {
            modal.classList.remove( 'loading' );
            modal.classList.add( 'error' );
            return;
        }

        clearGallery();
        assignSlots( data );
    } );

    getAll( 'a', modal ).forEach( link => link.addEventListener( 'click', () => {
        closeButton.click();
    } ) );

}


/**
 * @param {HutData} data
 *
 * @return void
 */
async function assignSlots( data ) {
    title_slot.innerHTML = data.title;
    price_slot.innerHTML = formatNumber( data.price );
    content_slot.innerHTML = data.description;
    length_slot.innerHTML = data.length;
    width_slot.innerHTML = data.width;
    link_slot.href = data.url;
    enquire_slot?.setAttribute( 'data-hut', data.title );
    assignFeatures( data.features );

    await assignGallery( data.gallery );
    modal.classList.remove( 'loading' );
}

function assignFeatures( features ) {
    const featuresWrap = features_slot.closest( '.hut-features' );
    if ( features.length === 0 ) {
        featuresWrap.style.display = 'none';
    } else {
        featuresWrap.style.removeProperty( 'display' );
    }

    features_slot.innerHTML = features.map( feature => `<li>${feature}</li>` ).join( '' );
}

async function assignGallery( ids ) {
    try {
        const gallery = await fetchGalleryHtml( ids );
        if ( gallery === null ) {
            errorGallery();
            return console.error( "No html was returned" );
        };
        if ( gallery instanceof Error ) {
            errorGallery();
            return console.error( gallery );
        };
        gallery_slot.appendChild( gallery );
        slickSlideGallery( gallery );
    } catch ( e ) {
        errorGallery();
        return console.error( 'Request failed' );
    }
}

function errorGallery() {
    gallery_slot.innerHTML = `
        <p class="hutodal__error">Failed to load image gallery</p>
    `;
}

function clearGallery() {
    gallery_slot.innerHTML = '';
}

/**
 * @param {number[]} ids
 *
 * @return {Promise<HTMLElement|Error|null>}
 */
async function fetchGalleryHtml( ids ) {
    try {
        // @ts-ignore WPObj inserted va inline js script globally
        const res = await fetch( `${WPObj.ajaxurl}?action=nu_gallery&image_ids=${ids}` );
        if ( !res.ok ) {
            console.dir( res );
            return new Error( 'Response is not ok' );
        };
        const text = await res.text();
        return textToHTML( text );
    } catch ( e ) {
        console.error( e );
        return e;
    }
}

function slickSlideGallery( gallery ) {
    const main = get( '[data-main]', gallery );
    const prevArrow = get( '[data-prev]', gallery );
    const nextArrow = get( '[data-next]', gallery );
    jQuery( main ).slick( {
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow,
        prevArrow,
        fade: true,
        autoplay: false,
    } );
}


/**
 * @param {number|string} id
 *
 * @return {Promise<HutData|Error>}
 */
async function fetchHutData( id ) {
    try {
        const hut_res = await fetch( `/wp-json/wp/v2/hut/${id}` );
        const hut_data = await hut_res.json();
        const data = mapHutWPJsonData( hut_data );
        return data;
    } catch ( e ) {
        console.error( e );
        return e;
    }
}


/**
 * @typedef HutData
 * @type {object}
 * @property {string} title
 * @property {string} price
 * @property {string} length
 * @property {string} width
 * @property {string} description HTML string containing the full description of the hut
 * @property {number[]} gallery an array of image ids
 * @property {string[]} features an arary of features in plain text
 * @property {string} url

 */

/**
 * @param mixed data
 *
 * @return {HutData}
 */
function mapHutWPJsonData( data ) {
    return {
        title: data.title.rendered,
        price: data.metadata.price,
        length: data.metadata.length,
        width: data.metadata.width,
        gallery: data.gallery_ids,
        features: data.features,
        description: data.description,
        url: data.link
    };
}